import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {} });

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('dark'); // default dark

    useEffect(() => {
        // Read from localStorage on mount; fall back to dark
        const stored = typeof window !== 'undefined'
            ? localStorage.getItem('ahl-theme')
            : null;
        const initial = stored || 'dark';
        setTheme(initial);
        applyTheme(initial);
    }, []);

    const applyTheme = (t) => {
        if (typeof document === 'undefined') return;
        if (t === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    };

    const toggleTheme = () => {
        const next = theme === 'dark' ? 'light' : 'dark';
        setTheme(next);
        applyTheme(next);
        if (typeof window !== 'undefined') {
            localStorage.setItem('ahl-theme', next);
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
